import React from 'react';
import ReactDOM from 'react-dom/client';
import { BuildersComponentsTrackingProvider } from '@gjensidige/builders-components';
import { TrackingProvider } from '@gjensidige/core-analytics';
import ErrorBoundary from '@gjensidige/service-error-boundary';

import tracker from './tracking';
import { App } from './App';

const rootElement = document.getElementsByClassName(
  'hgf-home-calculation-widget-root'
)[0];
ReactDOM.createRoot(rootElement!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BuildersComponentsTrackingProvider options={tracker.options}>
        <TrackingProvider options={tracker.options}>
          <App />
        </TrackingProvider>
      </BuildersComponentsTrackingProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
